export const TOKEN_KEY = 'token'
export const USER_ROLE_KEY = 'role'
